import Controller from "./bulkBonusDetails.controller";
import template from "./bulkBonusDetails.html";

const bulkBonusDetails = {
  template,
  controller: Controller,
};

export default bulkBonusDetails;



// WEBPACK FOOTER //
// ./src/pages/bulkBonusDetails/bulkBonusDetails.component.js